export default __webpack_public_path__ + "bg_day.0b4c721.svg";